import { isTaskShare } from './taskChatShare';
import { isAppointmentShare } from './appointmentChatShare';

// Short, kind-aware snippet of a message for the reply quote (in the composer
// bar and inline over the reply itself) — attachments/cards have no useful
// body text, so fall back to a label describing what they are.
export function replyPreviewText(m) {
  if (m.kind === 'code') return (m.body || '').split('\n')[0].slice(0, 140) || 'Code snippet';
  if (m.kind === 'image') return (m.body || '').trim().slice(0, 140) || 'Photo';
  if (m.kind === 'file') return m.metadata?.name || 'Attachment';
  if (m.kind === 'share') {
    if (isAppointmentShare(m.metadata)) return 'Shared an appointment';
    return isTaskShare(m.metadata) ? 'Shared a task' : m.metadata?.label || 'Shared item';
  }
  if (m.kind === 'secret') return `🔒 ${m.metadata?.label || 'Encrypted secret'}`;
  if (m.kind === 'ref') return m.metadata?.label || m.metadata?.type || 'Reference';
  return (m.body || '').trim().slice(0, 140);
}
